import { useEffect, useState } from 'react';
import { DownloadInvoiceIcon, NotesIcon, TokenIcon } from '../assets/svgImages';
import OrderItemsAndActions from './OrderItemsAndActions';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  addAuspostId,
  addNote,
  downloadOrderInvoice,
  getAllOrderStatues,
  getOrderDetails,
  resumeOrder,
  updateOrderStatus,
} from '../service/index';
import { useAuth } from 'react-oidc-context';
import Loading from './Loading';
import {
  CancelOrderPurpose,
  LoadStates,
  OrderInfoItem,
  OrderSasData,
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
  SelectedOrder,
  SelectedOrderAction,
} from '../interface/interface';
import { saveAs } from 'file-saver';
import { TinySpinner } from './TinySpinner';
import CustomModal from './CustomModal';
import Dropdown from './Dropdown';
import AddTokenModal from './AddTokenModal';
import TextAreaWithLimit from './TextArea';
import showToast from './ToastComponent';
import InfoField from './InfoField';
import moment from 'moment';
import { transformPhoneNumber } from '../utils/transformPhoneNumber';
import { createLabel } from '../service/createLabel';
import { AuspostFailureStatus } from './AuspostFailureStatus';
import { RetryShipmentButton } from './RetryShipmentButton';
import { AuspostTrackingURL } from '../constant/constant';
import { DeleteShipmentButton } from './DeleteShipmentButton';
import useDeleteShipment from '../hooks/useDeleteShipment';
import AwaitingSASButton from './AwaitingSASButton';
import Breadcrumbs from './Breadcrumbs';
import MedicationLabelCheckModal from './MedicationLabelCheckModal';
import InfoBox from './InfoBox';
import { cancelOrderRequestMessage } from '../helpers/cancelOrderRequestMessage';
import { handleDispensedStatus } from '../helpers/OrderStatusHandler/handleDispensedStatus';
import { handleAmendingDispensedStatus } from '../helpers/OrderStatusHandler/handleAmendingDispenseStatus';
import { handleShippedStatus } from '../helpers/OrderStatusHandler/handleShippedStatus';
import { handleAfteDispensedStatus } from '../helpers/OrderStatusHandler/handleAfterDispensedStatus';
import { handleInvalidOrderStatus } from '../helpers/OrderStatusHandler/handleInvalidOrderStatus';
import useRetryShipment from '../hooks/useRetryShipment';

const OrderSummaryAdminView = () => {
  const { orderId } = useParams();
  const { user } = useAuth();
  const navigateTo = useNavigate();

  // Imporsnate user navbar
  const [isSubsEnabled, setSubStatus] = useState<boolean>(false);
  const [hasExpiredPrescription, setHasExpiredPrescription] =
    useState<boolean>(false);

  const [selectedOrder, setOrder] = useState<SelectedOrder>();
  const [trackingID, SetTrackingID] = useState<string>('');
  const [AusPostIdEnabled, SetAusPostIdEnabled] = useState<boolean>(false);
  const [buttonType, setButtonType] = useState<string>('');
  const [totalQtyAlert, setTotalQtyAlert] = useState<boolean>(false);
  const [totalQty, setTotalQty] = useState<string>('');

  // Notes
  const [note, setNote] = useState<string>('');

  // Patient Section
  const [isPatientSectionLoading, setPatientSectionLoadingStatus] =
    useState<boolean>(false);
  const [summaryData, setSummaryData] = useState<OrderInfoItem>();

  // Action Loaders
  const [ausPostLoader, setAusPostLoading] = useState<LoadStates>({
    isLoading: false,
    isError: false,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTokenModalOpen, setTokenModalOpen] = useState(false);
  const [modalQuestion, setModalQuestion] = useState('');
  const [modalAction, setModalAction] = useState(() => () => {});

  // Download Invoice
  const [invoicedLoader, setInvoiceLoadStatus] = useState<LoadStates>({
    isLoading: false,
    isError: false,
  });

  // Fetch all Order Statues
  const [, setFetchOrderStatusLoading] = useState<boolean>(false);
  const [allOrderStatus, setAllOrderStatus] = useState<
    Array<OrderSelectionOptionItem>
  >([]);

  // Update Order Products
  const [, setOrderStatusLoader] = useState<LoadStates>({
    isError: false,
    isLoading: false,
  });
  const [orderStatusId, setOrderStatusId] = useState<number>();
  const [, setPatientRefreshCounter] = useState<number>(0);

  const [, setDefaultSelection] = useState<OrderSelectionOptionItem>();

  const [isMModalVisible, setMultiModalVisible] = useState<boolean>(false);
  const [hasSasProduct, setHasSasProduct] = useState<Array<OrderSasData>>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [alreadyOpen, setAlreadyOpen] = useState<boolean>(false);

  const openMultiModal = () => setMultiModalVisible(true);
  const closeMultiModal = () => setMultiModalVisible(false);

  // const AddTokenModalClick = () => {
  //   setTokenModalOpen(true);
  // };
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [handleDeleteShipment] = useDeleteShipment();
  const { mutateAsync, isPending } = useRetryShipment();

  const AddNotesModal = () => {
    setIsNotesModalOpen(true);
  };
  const CloseNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  // const AddTokenModalClick = () => {
  //   setTokenModalOpen(true);
  // };

  const handleAddTokenCloseClick = () => {
    setTokenModalOpen(false);
  };

  const handlePauseResumeClick = () => {
    if (summaryData?.currentStatus?.id === OrderStatusCode.INVALID) {
      if (!['Admin'].includes((user?.profile.groups as string[])[0])) {
        showToast({
          message: 'Admin only can handle the Invalid Order',
          type: 'info',
        });
        return;
      }
      setModalQuestion(
        'Are you sure you want to update the order status to Ordered?',
      );
      setModalAction(() => () => {
        setOrderStatusId(OrderStatusCode.ORDERED);
        setIsModalOpen(false);
      });
    } else if (summaryData?.currentStatus?.id !== OrderStatusCode.PAUSED) {
      setModalQuestion('Are you sure you want to pause the order?');
      setModalAction(() => () => {
        setOrderStatusId(OrderStatusCode.PAUSED);
        setIsModalOpen(false);
      });
    } else {
      setModalQuestion('Are you sure you want to resume the order?');
      setModalAction(
        () => () =>
          setOrder((p) => ({
            ...(p as SelectedOrder),
            action: SelectedOrderAction.RESUME_ORDER,
          })),
      );
    }
    setIsModalOpen(true);
  };

  const handleModalYesClick = () => {
    modalAction();
    setIsModalOpen(false);
    setTotalQtyAlert(false);
    setTotalQty('');
  };

  const handleModalCancelClick = () => {
    setIsModalOpen(false);
    setOrderStatusId(undefined);
    setTotalQtyAlert(false);
    setTotalQty('');
  };

  const handleAusPostIDchange = (e: any) => {
    const value = e.currentTarget.value;
    SetTrackingID(value);
    SetAusPostIdEnabled(value?.trim() !== '');
  };

  const onCreateLabel = async () => {
    if (!user?.access_token) return;

    const labelCreationResult = await createLabel(
      user?.access_token,
      Number(orderId),
    );

    if (labelCreationResult.status === 200) {
      const element = document.createElement('a');
      element.setAttribute('href', labelCreationResult.data.url);
      element.setAttribute('target', '_blank');
      element.click();
      return;
    }

    showToast({
      message: labelCreationResult.data,
      type: 'error',
    });
  };

  useEffect(() => {
    if (!user?.access_token) return;

    setFetchOrderStatusLoading(true);
    getAllOrderStatues(user.access_token).then((data) => {
      if (typeof data === 'number') {
        setFetchOrderStatusLoading(false);
        return;
      }
      setAllOrderStatus(data);
      setFetchOrderStatusLoading(false);
    });
  }, []);

  useEffect(() => {
    if (isNaN(Number(orderId))) return navigateTo('/404');

    setOrder({ action: SelectedOrderAction.INTIAL, orderId: Number(orderId) });
  }, [orderId]);

  useEffect(() => {
    if (!selectedOrder?.orderId || !user?.access_token) return;

    switch (selectedOrder.action) {
      case SelectedOrderAction.INTIAL:
        setPatientSectionLoadingStatus(true);
        getOrderDetails(user?.access_token, selectedOrder?.orderId).then(
          (data) => {
            if (typeof data === 'number') {
              if (data === 404) return navigateTo('/404');
              setPatientSectionLoadingStatus(false);
            }
            if (data?.patient?.patientNotes) {
              setOpen(true);
            }
            setDefaultSelection(data.currentStatus);
            setSummaryData(data);
            setNote(data.note ?? '');
            SetTrackingID(data?.ausPostId ?? '');
            setDefaultSelection({
              id: summaryData?.currentStatus?.id as number,
              name: summaryData?.currentStatus?.name as string,
              color_code: summaryData?.currentStatus?.colorCode as string,
            });
            setPatientSectionLoadingStatus(false);
          },
        );
        break;

      case SelectedOrderAction.ADD_AUSPOST:
        setAusPostLoading((prev) => ({ ...prev, isLoading: true }));
        addAuspostId(user.access_token, {
          refId: selectedOrder.orderId,
          ausPostId: trackingID,
        }).then((status): void => {
          setAusPostLoading({ isLoading: false, isError: status !== 200 });
          SetAusPostIdEnabled(status !== 200);
        });
        break;

      case SelectedOrderAction.RESUME_ORDER:
        setPatientSectionLoadingStatus(true);
        resumeOrder(user.access_token, selectedOrder.orderId).then((status) => {
          if (status === 200) {
            setOrder((p) => ({
              ...(p as SelectedOrder),
              action: SelectedOrderAction.INTIAL,
            }));
          }
          setPatientSectionLoadingStatus(false);
        });
        break;

      case SelectedOrderAction.INVOICE_DOWNLOAD:
        setInvoiceLoadStatus({ isError: false, isLoading: true });
        downloadOrderInvoice(user?.access_token, selectedOrder.orderId).then(
          (res) => {
            if (typeof res === 'number') {
              setInvoiceLoadStatus({
                isError: true,
                reason: 'Unable to download invoice',
                isLoading: false,
              });
              return;
            }

            saveAs(res?.data, 'invoice.pdf');
            setInvoiceLoadStatus({ isError: false, isLoading: false });
            setOrder((prev) => ({
              ...(prev as SelectedOrder),
              action: SelectedOrderAction.DONT_RERENDER,
            }));
          },
        );
        break;

      default:
        break;
    }
  }, [selectedOrder]);

  useEffect(() => {
    function updateTrigger() {
      if (!user?.access_token || !orderStatusId) return;
      setOrderStatusLoader((prev) => ({ ...prev, isLoading: true }));
      updateOrderStatus(user.access_token, {
        orderId: selectedOrder?.orderId as number,
        orderStatusIdToUpdate: orderStatusId,
      }).then((res): void => {
        setOrderStatusId(undefined);
        if (typeof res === 'number' || !res) return;
        if (res.status === 200) {
          setPatientRefreshCounter((p) => p + 1);
          setOrder((p) => ({
            ...(p as SelectedOrder),
            action: SelectedOrderAction.INTIAL,
          }));
          setDefaultSelection(
            allOrderStatus.find((e) => e?.id === orderStatusId),
          );
        }
        setOrderStatusLoader({
          isError: res.status !== 200,
          isLoading: false,
          reason: res.status !== 200 ? 'Unable to update order status' : '',
        });

        if (res.status !== 200) {
          showToast({
            message: `Unable to Update: ${res?.data?.message}`,
            type: 'warning',
          });
        }
      });
    }

    // Handling modal actions here except `Pause` and `Resume`
    switch (orderStatusId) {
      case OrderStatusCode.CANCELLED:
        setModalQuestion('Are you sure you want to cancel the order?');
        setModalAction(() => () => {
          updateTrigger();
          setIsModalOpen(false);
          showToast({
            message: 'Order successfully cancelled',
            type: 'success',
          });
        });
        setIsModalOpen(true);
        break;

      case OrderStatusCode.DISPENSED:
        setModalQuestion('Are you sure you want to dispense the order?');
        setModalAction(() => () => {
          updateTrigger();
          setIsModalOpen(false);
        });
        setIsModalOpen(true);
        break;

      case OrderStatusCode.READY_FOR_SHIPPING:
        setModalQuestion(
          'Are you sure you want to move the order to Ready for Shipping?',
        );
        setModalAction(() => () => {
          updateTrigger();
          setIsModalOpen(false);
        });
        setIsModalOpen(true);
        break;

      case OrderStatusCode.PARCEL_RETURNED:
        setModalQuestion(
          'Are you sure you want to move the order status from Shipped to Parcel Returned ?',
        );
        setModalAction(() => () => {
          updateTrigger();
          setIsModalOpen(false);
        });
        setIsModalOpen(true);
        break;

      default:
        updateTrigger();
        return;
    }
  }, [orderStatusId]);

  if (isPatientSectionLoading || isPending) return <Loading />;

  function getOptionsById() {
    const commonAdminStatuses = [
      OrderStatusCode.READY_FOR_SCAN,
      OrderStatusCode.READY_FOR_SHIPPING,
      OrderStatusCode.SHIPPED,
      OrderStatusCode.ORDERED,
      OrderStatusCode.DISPENSING,
      OrderStatusCode.DISPENSED,
    ];

    switch (true) {
      case (summaryData?.currentStatus?.id as number) ===
        OrderStatusCode.INVALID:
        return handleInvalidOrderStatus(user?.profile.groups, allOrderStatus, [
          ...commonAdminStatuses,
          OrderStatusCode.CANCELLED,
        ]);

      case (summaryData?.currentStatus?.id as number) <
        OrderStatusCode.DISPENSED:
        return handleDispensedStatus(
          user?.profile.groups,
          allOrderStatus,
          commonAdminStatuses,
        );

      case (summaryData?.currentStatus?.id as number) ===
        OrderStatusCode.AMENDING_DISPENSE:
        return handleAmendingDispensedStatus(
          user?.profile.groups,
          allOrderStatus,
          commonAdminStatuses,
        );

      case (summaryData?.currentStatus?.id as number) ===
        OrderStatusCode.SHIPPED:
        return handleShippedStatus(user?.profile.groups, allOrderStatus, [
          ...commonAdminStatuses,
          OrderStatusCode.PARCEL_RETURNED,
        ]);

      case (summaryData?.currentStatus?.id as number) >=
        OrderStatusCode.DISPENSED:
        return handleAfteDispensedStatus(
          user?.profile.groups,
          allOrderStatus,
          commonAdminStatuses,
        );

      default:
        allOrderStatus.filter(
          (s) =>
            ![
              OrderStatusCode.CANCELLED,
              OrderStatusCode.PAUSED,
              OrderStatusCode.INVALID,
              OrderStatusCode.CANCELLATION_REQUEST,
            ].includes(s?.id),
        );
    }
  }

  const handleNoteUpdate = async () => {
    if (!summaryData?.id || !user?.access_token) {
      showToast({
        message: 'Missing Required Creds',
        type: 'info',
      });
      return;
    }
    const orderUpdate = await addNote(
      summaryData?.id,
      note,
      user?.access_token,
    );

    if (orderUpdate === 200) {
      showToast({
        message: 'Notes added',
        type: 'success',
      });
      CloseNotesModal();
      setOrder((p) => ({
        ...(p as SelectedOrder),
        action: SelectedOrderAction.INTIAL,
      }));
      return;
    }

    showToast({
      message: 'Unable to add Notes',
      type: 'error',
    });
    CloseNotesModal();
  };
  const unformattedPhoneNumber = summaryData?.patient?.phone?.mobile;
  const formattedPhoneNumber = unformattedPhoneNumber
    ? transformPhoneNumber(unformattedPhoneNumber)
    : '-';

  const canShowStatusDropdown = (
    statusId: number | undefined,
    userRole: string | undefined,
  ) => {
    const invalidStatuses = [
      OrderStatusCode.CANCELLED,
      OrderStatusCode.PAUSED,
      OrderStatusCode.AUSPOST_FAILURE,
      OrderStatusCode.AWAITING_SAS_B,
      OrderStatusCode.INVALID,
      OrderStatusCode.PARCEL_RETURNED,
    ];

    return (
      !invalidStatuses.includes(statusId as number) ||
      (statusId === OrderStatusCode.INVALID && userRole === ROLE.Admin)
    );
  };

  const handleModalClose = () => {
    setOpen(false);
    setAlreadyOpen(true);
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <div>
          <Breadcrumbs
            data={[
              {
                tag: 'a',
                className: 'mr-3',
                href: '/admin/orders',
                children: <>Orders</>,
              },
              {
                tag: 'p',
                children: <span>Order Summary</span>,
              },
            ]}
          />
          <h2 className="text-xl flex items-center text-primary-blue-500 font-semibold">
            Order Summary for &nbsp;
            <span className="text-secondary-pink-600">
              #{summaryData?.invoiceId}
            </span>
            {summaryData?.impersonatedBy && (
              <span className="text-base font-regular ml-4">
                <span className="font-bold">*</span>This order was placed by{' '}
                {summaryData?.impersonatedBy?.name} (
                {summaryData?.impersonatedBy?.role})
              </span>
            )}
          </h2>
        </div>
        <div>
          <button
            className="m-2 bg-white text-primary-blue-500 border border-primary-blue-500 p-3 2.5xl:px-6 2.5xl:py-3 text-sm font-semibold rounded"
            onClick={() => navigateTo(`/order/history/${orderId}`)}
          >
            View Status History
          </button>
          <button
            className="m-2 bg-white text-primary-blue-500 border border-primary-blue-500 p-3 2.5xl:px-6 2.5xl:py-3 text-sm font-semibold rounded"
            onClick={() => navigateTo(`/order/tracking/${orderId}`)}
          >
            View Tracking History
          </button>
        </div>
      </div>
      <button
        onClick={AddNotesModal}
        className="bg-primary-blue-500 text-white text-base font-semibold pl-4 pr-2 
        rounded-l-full py-3 fixed right-0 top-28 3xl:top-36 flex items-center -mt-6 2.5xl:mt-5"
      >
        <NotesIcon />
        <span className="ml-2">Add note</span>
      </button>
      {summaryData?.cancelOrderRequest?.status &&
      summaryData?.cancelOrderRequest?.status !== CancelOrderPurpose.Request ? (
        <InfoBox
          className="border border-blue-200 bg-blue-50 text-primary-blue-500 my-4"
          isIconEnable={true}
          iconClassName="w-6 fill-blue-400 mr-2"
          content={cancelOrderRequestMessage(
            summaryData?.cancelOrderRequest?.status,
          )}
          boldContent={summaryData?.cancelOrderRequest?.reason as string}
        />
      ) : null}
      <div className="mt-4 bg-white rounded-md p-5 2xl:p-8 shadow mb-10">
        <p className="mb-4">
          <span className="text-secondary-pink-600 text-base font-semibold">
            Order Date:{' '}
          </span>
          <span className="text-primary-blue-500 text-sm">
            {summaryData?.createdDate
              ? moment(summaryData?.createdDate).format('DD/MM/YYYY')
              : ' - '}
          </span>
        </p>
        <div className="flex flex-wrap items-center">
          <div className="basis-2/5 flex items-center">
            <h3 className="text-2xl text-primary-blue-500 font-semibold mr-3">
              {summaryData?.patient?.firstName} {summaryData?.patient?.lastName}
            </h3>

            {summaryData?.patient?.isGuest ? (
              <span
                className={
                  'px-5 py-1 rounded-full uppercase text-xs text-white font-semibold bg-secondary-green-500'
                }
              >
                Guest
              </span>
            ) : (
              <button
                className="border border-secondary-pink-600 text-secondary-pink-600 bg-white px-4 py-3 text-sm md:text-sm font-semibold rounded"
                onClick={() => {
                  navigateTo(`/patient/${summaryData?.patient?.id}`);
                }}
              >
                View Patient Profile
              </button>
            )}
          </div>
          <div className="basis-3/5 flex justify-end items-center">
            <p className="mr-6 text-base text-primary-blue-500 font-semibold flex items-center">
              <span
                className="block rounded-full w-2.5 h-2.5 mr-2.5"
                style={{
                  backgroundColor: summaryData?.currentStatus?.colorCode,
                }}
              ></span>
              <span>
                {summaryData?.currentStatus?.id ===
                OrderStatusCode.AUSPOST_FAILURE ? (
                  <AuspostFailureStatus
                    reason={summaryData.shipmentFailureReason!}
                  />
                ) : (
                  summaryData?.currentStatus?.name
                )}
              </span>
            </p>
            <div className="mr-4">
              {canShowStatusDropdown(
                summaryData?.currentStatus?.id,
                (user?.profile.groups as string[])?.[0],
              ) && (
                <Dropdown
                  defaultText="Change status"
                  defaultSelected={
                    {
                      ...summaryData?.currentStatus,
                      color_code: summaryData?.currentStatus?.colorCode,
                    } as OrderSelectionOptionItem
                  }
                  options={getOptionsById() ?? []}
                  onSelect={(id: number) => setOrderStatusId(id)}
                />
              )}
            </div>
            <RetryShipmentButton
              currentOrderStatus={summaryData?.currentStatus?.id}
              setLoading={(status) => {
                setPatientSectionLoadingStatus(status);
                if (!status)
                  setOrder({
                    action: SelectedOrderAction.INTIAL,
                    orderId: Number(orderId),
                  });
              }}
              orderId={summaryData?.id as number}
              failureReason={summaryData?.shipmentFailureReason as string}
              hasDeletedShipment={summaryData?.isShipmentDeleted as boolean}
              handleModalClick={() => {
                setIsModalOpen(true);
                setModalAction(() => async () => {
                  await mutateAsync({
                    accessToken: user?.access_token!,
                    orderId: Number(orderId),
                  });
                  setOrder({
                    orderId: Number(orderId),
                    action: SelectedOrderAction.INTIAL,
                  });
                });
                setModalQuestion(
                  'Are you sure you want to create/revert the shipment?',
                );
              }}
            />
            <DeleteShipmentButton
              userToken={user?.access_token}
              auspostTrackingId={trackingID}
              currentOrderStatus={summaryData?.currentStatus?.id}
              hasDeletedShipment={summaryData?.isShipmentDeleted as boolean}
              handleModalClick={() => {
                setIsModalOpen(true);
                setModalAction(() => async () => {
                  await handleDeleteShipment(
                    user?.access_token,
                    Number(orderId),
                  );
                  setOrder({
                    orderId: Number(orderId),
                    action: SelectedOrderAction.INTIAL,
                  });
                });
                setModalQuestion(
                  'Are you sure you want to delete the shipment?',
                );
              }}
            />
            <AwaitingSASButton
              orderStatusId={summaryData?.currentStatus?.id as number}
              userGroups={[
                ROLE.Admin.toString(),
                ROLE.Pharmacist.toString(),
                ROLE.PLO.toString(),
                ROLE.Dispense_Tech.toString(),
              ].includes((user?.profile.groups as string[])[0])}
              handleOrderStatus={setOrderStatusId}
              sasProductData={hasSasProduct}
              accessToken={user?.access_token as string}
              orderId={summaryData?.id as number}
              patientId={summaryData?.patient?.id as number}
              refreshPage={() => {
                setOrder({
                  orderId: Number(orderId),
                  action: SelectedOrderAction.INTIAL,
                });
              }}
            />
            <button
              className={`bg-secondary-green-100 text-primary-blue-500 p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded mr-6 ${
                [
                  OrderStatusCode.CANCELLED,
                  OrderStatusCode.SHIPPED,
                  OrderStatusCode.AUSPOST_FAILURE,
                ].includes(summaryData?.currentStatus?.id as OrderStatusCode) ||
                (summaryData?.currentStatus?.id === OrderStatusCode.INVALID &&
                  !['Admin'].includes((user?.profile.groups as string[])[0]))
                  ? 'opacity-50 cursor-not-allowed'
                  : ''
              }`}
              disabled={
                [
                  OrderStatusCode.CANCELLED,
                  OrderStatusCode.SHIPPED,
                  OrderStatusCode.AUSPOST_FAILURE,
                ].includes(summaryData?.currentStatus?.id as OrderStatusCode) ||
                (summaryData?.currentStatus?.id === OrderStatusCode.INVALID &&
                  !['Admin'].includes((user?.profile.groups as string[])[0]))
              }
              onClick={handlePauseResumeClick}
            >
              {summaryData?.currentStatus?.id === OrderStatusCode.PAUSED ||
              summaryData?.currentStatus?.id === OrderStatusCode.INVALID
                ? 'Resume'
                : 'Pause'}{' '}
              Order
            </button>
            {['Admin', 'Pharmacist'].includes(
              (user?.profile.groups as string[])[0],
            ) && (
              <button
                className={`bg-primary-red-600 text-white p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded ${
                  [
                    OrderStatusCode.CANCELLED,
                    OrderStatusCode.AUSPOST_FAILURE,
                  ].includes(
                    summaryData?.currentStatus?.id as OrderStatusCode,
                  ) ||
                  (summaryData?.currentStatus?.id === OrderStatusCode.SHIPPED &&
                    !['Admin'].includes((user?.profile.groups as string[])[0]))
                    ? 'opacity-50 cursor-not-allowed'
                    : ''
                }`}
                onClick={() => setOrderStatusId(OrderStatusCode.CANCELLED)}
                disabled={
                  [
                    OrderStatusCode.CANCELLED,
                    OrderStatusCode.AUSPOST_FAILURE,
                  ].includes(
                    summaryData?.currentStatus?.id as OrderStatusCode,
                  ) ||
                  (summaryData?.currentStatus?.id === OrderStatusCode.SHIPPED &&
                    !['Admin'].includes((user?.profile.groups as string[])[0]))
                }
              >
                Cancel Order
              </button>
            )}
          </div>
        </div>
        <div className="flex justify-between mt-8 mb-5 border-b border-secondary-cornflowerblue-500">
          <InfoField
            label="Date of Birth"
            value={
              summaryData?.patient?.dob
                ? moment.utc(summaryData?.patient?.dob).format('DD-MM-YYYY')
                : ' - '
            }
          />
          <InfoField
            label="Patient Email"
            value={
              summaryData?.patient?.email ? summaryData?.patient?.email : ' - '
            }
            className="w-4/5 break-words"
          />
          <InfoField label="Patient Phone" value={formattedPhoneNumber} />
          <InfoField
            label="Shipping Address"
            value={
              summaryData?.patient?.address
                ? `${summaryData?.patient?.address?.firstName} 
              ${summaryData?.patient?.address?.lastName}, 
              ${summaryData?.patient?.address?.addressLine1}, 
              ${
                summaryData?.patient?.address?.addressLine2
                  ? `${summaryData?.patient?.address?.addressLine2},`
                  : ''
              } 
                ${summaryData?.patient?.address?.city} 
                ${summaryData?.patient?.address?.zipCode} ${summaryData?.patient?.address?.province} 
                Australia`
                : ' - '
            }
          />
        </div>
        {summaryData?.note && (
          <p className="flex items-center mb-4">
            <span className="text-xl text-secondary-pink-700 font-semibold">
              Order Notes:
            </span>
            <span className="text-lg text-primary-blue-500 font-regular ml-3">
              {summaryData.note}
            </span>
          </p>
        )}
        <OrderItemsAndActions
          patient={{
            id: summaryData?.patient?.id,
            email: summaryData?.patient?.email,
          }}
          orderId={orderId}
          accessToken={user?.access_token}
          modalProps={{
            isMModalVisible,
            setMultiModalVisible,
            closeMultiModal,
          }}
          setSubsFlag={setSubStatus}
          setPresciptionExpiryFlag={setHasExpiredPrescription}
          refreshParent={() =>
            setOrder({
              action: SelectedOrderAction.INTIAL,
              orderId: Number(orderId),
            })
          }
          tokenType={buttonType}
          sasProductData={setHasSasProduct}
        />
        <div className="flex justify-between">
          <div className="w-2/5">
            {((user?.profile.groups as string[]).includes('PLO') ||
              (user?.profile.groups as string[]).includes('Admin') ||
              (user?.profile.groups as string[]).includes('Pharmacist') ||
              (user?.profile.groups as string[]).includes('Dispense_Tech')) && (
              <>
                <div className="flex my-10">
                  {isSubsEnabled && (
                    <button
                      className="bg-primary-red-100 rounded-md px-6 py-3 text-base text-primary-blue-500 me-5 flex font-semibold"
                      onClick={() => {
                        openMultiModal();
                        setButtonType('Substitute');
                      }}
                    >
                      <TokenIcon className="mr-3" />
                      Add Substitute Token
                    </button>
                  )}
                  {hasExpiredPrescription && (
                    <button
                      className="bg-primary-red-100 rounded-md px-6 py-3 text-base text-primary-blue-500 flex font-semibold"
                      onClick={() => {
                        openMultiModal();
                        setButtonType('New Prescription');
                      }}
                    >
                      <TokenIcon className="mr-3" />
                      Add New Prescription
                    </button>
                  )}
                </div>
              </>
            )}
            <div className="flex mt-10">
              <input
                type="text"
                className="border border-solid border-primary-blue-500 rounded-md px-6 py-3 text-base font-regular mr-4"
                placeholder="AusPost Tracking ID"
                value={trackingID}
                onChange={handleAusPostIDchange}
              />
              <button
                className={`rounded-md text-white text-base px-12 py-3 ${
                  AusPostIdEnabled
                    ? 'bg-primary-blue-500'
                    : 'bg-secondary-cornflowerblue-400 cursor-not-allowed'
                }`}
                disabled={!AusPostIdEnabled || ausPostLoader.isLoading}
                onClick={() =>
                  setOrder((prev) => ({
                    ...(prev as SelectedOrder),
                    action: SelectedOrderAction.ADD_AUSPOST,
                  }))
                }
              >
                Save
              </button>
            </div>
            {trackingID && (
              <div className="mt-3 underline text-primary-blue-500 font-semibold">
                <Link
                  to={`${AuspostTrackingURL}/${trackingID}`}
                  target="_blank"
                >
                  Track in Auspost
                </Link>
              </div>
            )}
          </div>

          <div className="flex flex-col w-3/5 items-end">
            <div className="flex">
              {!summaryData?.isManifested && summaryData?.isShipped ? (
                <button
                  className="border-0 bg-transparent text-primary-blue-500 font-semibold font-base flex items-center mr-3 my-10"
                  onClick={() => onCreateLabel()}
                >
                  Create Label
                  <DownloadInvoiceIcon className="ml-3" />
                </button>
              ) : null}

              <button
                className={
                  'border-0 bg-transparent text-primary-blue-500 font-semibold font-base flex items-center mr-3 my-10 ' +
                  `${
                    (summaryData?.currentStatus?.id as number) <
                      OrderStatusCode.DISPENSED ||
                    (summaryData?.currentStatus?.id as number) ===
                      OrderStatusCode.PAUSED
                      ? 'cursor-not-allowed	opacity-50'
                      : ''
                  }`
                }
                onClick={() =>
                  setOrder((prev) => ({
                    ...(prev as SelectedOrder),
                    action: SelectedOrderAction.INVOICE_DOWNLOAD,
                  }))
                }
                disabled={
                  (summaryData?.currentStatus?.id as number) <
                    OrderStatusCode.DISPENSED ||
                  (summaryData?.currentStatus?.id as number) ===
                    OrderStatusCode.PAUSED
                }
              >
                <span>Download Invoice</span>
                {invoicedLoader.isLoading ? (
                  <TinySpinner />
                ) : (
                  <DownloadInvoiceIcon className="ml-3" />
                )}
              </button>
            </div>
            <div className="w-full md:w-9/12 lg:w-8/12 rounded-md bg-secondary-cornflowerblue-50 mb-5">
              <div className="w-9/12 mx-auto pt-8">
                {summaryData?.discount !== '0.00' && (
                  <p className="flex justify-between pb-3 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Discounts
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      - ${summaryData?.discount}
                    </span>
                  </p>
                )}
                {summaryData?.appliedGiftCards !== '0.00' && (
                  <p className="flex justify-between pb-3 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Applied Gift Cards
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      - ${summaryData?.appliedGiftCards}
                    </span>
                  </p>
                )}
                <p className="flex justify-between pb-3 items-center">
                  <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                    Card Surcharge
                  </label>
                  <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                    ${summaryData?.creditCardProcessingFee}
                  </span>
                </p>
                <p className="flex justify-between pb-3 items-center">
                  <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                    Subtotal
                  </label>
                  <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                    ${summaryData?.subTotal}
                  </span>
                </p>
                <p className="flex justify-between pb-3 items-center">
                  <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                    Shipping
                  </label>
                  <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                    ${summaryData?.shippingCost?.toFixed(2)}
                  </span>
                </p>
                {summaryData?.taxes !== '0.00' ? (
                  <p className="flex justify-between pb-5 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Taxes
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      ${summaryData?.taxes}
                    </span>
                  </p>
                ) : (
                  <></>
                )}
              </div>
              <div className="refund-block">
                <hr className="w-11/12 mb-5 mx-auto border-secondary-cornflowerblue-400"></hr>
                <div className="w-9/12 mx-auto">
                  <p className="flex justify-between pb-5 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Invoice Total
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      ${summaryData?.invoiceTotal}
                    </span>
                  </p>
                </div>
                <hr className="w-11/12 mb-5 mx-auto border-secondary-cornflowerblue-400"></hr>
                {summaryData?.refunded && (
                  <div className="w-9/12 mx-auto">
                    <p className="flex justify-between pb-5 items-center">
                      <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                        Refunded
                      </label>
                      <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                        -${summaryData.refunded}
                      </span>
                    </p>
                  </div>
                )}
              </div>
              <div className="bg-primary-blue-500 rounded-b-md">
                <p className="flex justify-between items-center w-9/12 py-6 mx-auto">
                  <label className="text-white text-base md:text-xl font-semibold">
                    Net Payment
                  </label>
                  <span className="text-white text-sm md:text-lg font-regular">
                    ${summaryData?.netPayment}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        onClose={handleModalCancelClick}
        header="Confirmation"
        footer={
          <>
            <button
              className={`mr-4 bg-primary-blue-500 text-white px-4 py-2 w-24 rounded ${
                [
                  OrderStatusCode.DISPENSED,
                  OrderStatusCode.READY_FOR_SHIPPING,
                ].includes(orderStatusId as number) &&
                (totalQtyAlert || !totalQty)
                  ? 'cursor-not-allowed opacity-50'
                  : ''
              }`}
              onClick={handleModalYesClick}
              disabled={
                [
                  OrderStatusCode.DISPENSED,
                  OrderStatusCode.READY_FOR_SHIPPING,
                ].includes(orderStatusId as number) &&
                (totalQtyAlert || !totalQty)
              }
            >
              Yes
            </button>
            <button
              className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 w-24 px-4 py-2 rounded"
              onClick={handleModalCancelClick}
            >
              Cancel
            </button>
          </>
        }
      >
        <p>{modalQuestion}</p>
        {[
          OrderStatusCode.DISPENSED,
          OrderStatusCode.READY_FOR_SHIPPING,
        ].includes(orderStatusId as number) ? (
          <MedicationLabelCheckModal
            currentStatusId={orderStatusId as number}
            isQtyAlert={totalQtyAlert}
            totalQty={totalQty}
            itemCount={summaryData?.totalOrderedQty as number}
            setTotalQty={setTotalQty}
            setTotalQtyAlert={setTotalQtyAlert}
          />
        ) : (
          <></>
        )}
      </CustomModal>
      <AddTokenModal
        isTokenModalOpen={isTokenModalOpen}
        handleAddTokenCloseClick={handleAddTokenCloseClick}
        orderId={orderId}
        accessToken={user?.access_token}
      />
      <CustomModal
        isOpen={isNotesModalOpen}
        onClose={CloseNotesModal}
        header="Add Note"
        footer={
          <div className="flex">
            <button
              className="text-sm px-3 py-2 bg-primary-blue-500 border border-primary-blue-500 text-white rounded-md"
              onClick={() => handleNoteUpdate()}
            >
              Save
            </button>
            <button
              onClick={CloseNotesModal}
              className="text-sm px-3 py-2 bg-white border border-primary-blue-500 text-primary-blue-500 rounded-md ml-3"
            >
              Cancel
            </button>
          </div>
        }
        modalSize="w-10/12 md:w-5/12 3xl:w-3/12"
      >
        <div className="flex flex-col">
          <label className="text-sm text-primary-blue-500 font-semibold mb-4">
            Please add your note below:
          </label>
          <TextAreaWithLimit
            maxLength={256}
            text={note}
            onTextChange={(text: string) => {
              setNote(text);
            }}
          />
        </div>
      </CustomModal>

      <CustomModal
        isOpen={open && !alreadyOpen}
        onClose={handleModalClose}
        header="Patient Notes"
        footer={
          <div className="flex">
            <button
              className="text-sm px-3 py-2 bg-primary-blue-500 border border-primary-blue-500 text-white rounded-md"
              onClick={handleModalClose}
            >
              Close
            </button>
          </div>
        }
        modalSize="w-10/12 md:w-5/12 3xl:w-3/12"
      >
        <div className="flex flex-col">
          <p className="text-sm text-primary-blue-500 mb-4 p-0 m-0">
            {summaryData?.patient?.patientNotes}
          </p>
        </div>
      </CustomModal>
    </>
  );
};

export default OrderSummaryAdminView;
